export default function assertBrowserEnv(): void {
  if (typeof window !== 'object') {
    throw new Error('This hook can only be called in a browser environment.')
  }
}
